import React from 'react';

import {
  Filter,
  Box,
  InputField,
  ListItem,
  DatepickerGroup,
  useWindowSize,
  Typography,
} from 'vindi-ds-components';

import { PrDownload } from 'vindi-ds-icons/pr';

const FilterQuickContainer = ({ onClickDownload }) => {
  const actions = [
    { label: 'Exportar', icon: <PrDownload />, onClick: onClickDownload },
  ];

  return (
    <Filter.QuickContainer actions={actions}>
      <Box width={{ sm: '100%', md: '288px' }}>
        <InputField name='period' placeholder='Escolha um período' select>
          <ListItem value='today'>Hoje</ListItem>
        </InputField>
      </Box>
    </Filter.QuickContainer>
  );
};

const Input = ({
  name,
  label,
  placeholder,
  select,
  options,
  multiOpts,
}) => {
  if (select) {
    return (
      <InputField
        name={name}
        label={label}
        placeholder={placeholder}
        select={select}
        multiOpts={multiOpts}
      >
        {
          options.map((option) => (
            <ListItem key={option.id} value={option.value}>{option.label}</ListItem>
          ))
        }
      </InputField>
    );
  }

  return (
    <InputField name={name} label={label} />
  );
};

const FilterPeriod = ({
  title,
  initial,
  final,
}) => {
  const { isMobile } = useWindowSize();

  return (
    <Box width='100%'>
      <Box m={0.5}>
        {!isMobile && <Typography color='textPrimary'>{title}</Typography>}
      </Box>

      <Box
        display='grid'
        gridTemplateColumns={{ sm: '1fr', md: '1fr 1fr' }}
        gap={1}
      >
        <DatepickerGroup>
          <InputField
            name={initial.name}
            label={initial.label}
            placeholder={initial.placeholder}
            selectsStart
            datepicker
            hasRange
          />
          <InputField
            name={final.name}
            label={final.label}
            placeholder={final.placeholder}
            selectsEnd
            datepicker
            hasRange
          />
        </DatepickerGroup>
      </Box>
    </Box>
  );
};

const FilterAdvancedFirstColumn = ({ className, filterFields }) => {
  const { isMobile } = useWindowSize();

  const { start, end } = isMobile
    ? filterFields.filters.advanced.periods.mobile
    : filterFields.filters.advanced.periods.desktop;

  return (
    <Filter.Column className={className}>
      <Box display='grid' gridTemplateColumns='1fr' gap={{ xs: 2, md: 3 }}>
        <FilterPeriod {...start} />
        <FilterPeriod {...end} />

        {
          filterFields.filters.advanced.firstColumn.map((field) => (
            <Input
              key={field.id}
              {...field}
            />
          ))
        }
      </Box>
    </Filter.Column>
  );
};

const FilterAdvancedSecondColumn = ({ className, filterFields }) => (
  <Filter.Column className={className}>
    <Box mt={{ xs: 1, sm: 0 }}>
      <Box display='grid' gridTemplateColumns='1fr' gap={{ xs: 2, md: 3 }}>
        {
          filterFields.filters.advanced.secondColumn.map((field) => (
            <Input
              key={field.id}
              {...field}
            />
          ))
        }
      </Box>
    </Box>
  </Filter.Column>
);

const FilterAdvancedContainer = ({ filterFields }) => (
  <Filter.AdvancedContainer>
    <FilterAdvancedFirstColumn
      filterFields={filterFields}
    />
    <FilterAdvancedSecondColumn
      filterFields={filterFields}
    />
  </Filter.AdvancedContainer>
);

const FiltersBills = ({ onClickDownload, filterFields }) => (
  <Box mt={3}>
    <FilterQuickContainer
      onClickDownload={onClickDownload}
    />

    <FilterAdvancedContainer
      filterFields={filterFields}
    />
  </Box>
);

export default FiltersBills;
